export default __webpack_public_path__ + "static/media/7UT512.3dc180ed.png";